import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnBlockValue,
  returnUserContent,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

import { RiStarLine } from 'react-icons/ri'

const LinkBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)

  // manifest settings
  const [opBlocks] = useAtom(manifestBlocks)
  const [opDesign] = useAtom(manifestDesign)
  const [pageDesign] = useAtom(pageContentDesign)

  // custom page settings
  const [getUserContents, setUserContents] = useAtom(userContents)

  function goToLink(link) {
    if (builder) {
    } else {
      if (link) {
        window.open(link, '_blank').focus()
      }
    }
  }

  return (
    <div
      onClick={() => {
        goToLink(
          returnBlockValue('link_url', 'content', opBlocks[block], content)
        )
      }}
      className={Classnames(
        'transition-all duration-500 ease-in-out transform cursor-pointer px-3 py-3 rounded flex items-center relative',
        {
          // is_featured
          'bg-yellow-300 hover:bg-yellow-400 text-yellow-800 border-yellow-500 animate-bounce':
            returnBlockValue('featured', 'content', opBlocks[block], content) ==
            'yes',
          // design options
          'shadow hover:shadow-lg hover:-translate-y-1 hover:scale-105 bg-white border-2 border-black ':
            returnValue('linkstyle', opDesign, pageDesign) == 'default',
          'shadow hover:shadow-lg hover:-translate-y-1 hover:scale-105 border-2 border-black bg-black text-white':
            returnValue('linkstyle', opDesign, pageDesign) == 'style2',
        }
      )}
    >
      <div className="mr-3 h-12">
        {returnBlockValue('link_img', 'content', opBlocks[block], content) && (
          <div
            className="w-14 h-12 rounded bg-no-repeat bg-cover"
            style={{
              backgroundImage:
                'url(' +
                returnBlockValue(
                  'link_img',
                  'content',
                  opBlocks[block],
                  content
                ) +
                ')',
            }}
          ></div>
        )}

        {/* <img
          src={returnBlockValue(
            'link_img',
            'content',
            opBlocks[block],
            content
          )}
          alt={
            'Go To ' +
            returnBlockValue('link_text', 'content', opBlocks[block], content)
          }
          className="w-14 h-12 rounded"
        /> */}
      </div>
      <div className="flex w-full justify-center font-bold">
        {returnBlockValue('link_text', 'content', opBlocks[block], content)}
      </div>

      {/* featuredStar */}
      {returnBlockValue('featured', 'content', opBlocks[block], content) ==
        'yes' && (
        <div className="absolute bg-yellow-500 text-xl text-white border-2 border-yellow-500 rounded-full p-1 -top-2 -right-2">
          <RiStarLine />
        </div>
      )}
    </div>
  )
}

export default LinkBlock
